import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { TaskServiceInterface } from './definitions/task-service-interface';
import { Observable } from 'rxjs';
import { ErrorsInterface } from '../errors/errors-interface';
import { DocumentNode } from 'graphql';
import { FetchResult } from '@apollo/client/core';

interface ToRevisionResponse {
  task: {
    sendToRevision: {
      output: TaskServiceInterface;
      errors: ErrorsInterface;
    };
  };
}

@Injectable()
export class TaskToRevisionService {
  constructor(private apollo: Apollo) {}

  toRevision(
    taskId,
    mutation: DocumentNode
  ): Observable<FetchResult<ToRevisionResponse>> {
    return this.apollo.mutate<ToRevisionResponse>({
      mutation: mutation,
      variables: {
        taskId,
      },
    });
  }
}
